<div class="madm">
  <header class="madm-header">
    <h1>Links de campaña</h1>

    <div class="madm-rango">
      <button [class.on]="rango === '7'" (click)="cambiarRango('7')">7 días</button>
      <button [class.on]="rango === '30'" (click)="cambiarRango('30')">30 días</button>
      <button [class.on]="rango === 'todo'" (click)="cambiarRango('todo')">Todo</button>
    </div>
  </header>

  <p class="madm-nota">
    Un clic cuenta una vez por navegador. El registro queda atado al link cuando
    la persona verifica su correo; el alta, el KYC y el fondeo se leen de la
    base al abrir esta pantalla. El rango filtra por la fecha del clic.
  </p>

  <div class="madm-cargando" *ngIf="cargando">Cargando…</div>
  <div class="madm-error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!cargando && !error">
    <section class="madm-link" *ngFor="let e of embudos; let i = index">
      <div class="madm-link-cab">
        <h2>{{ e.nombre }}</h2>
      </div>

      <div class="madm-compartir">
        <!--
          El QR se dibuja a tamano de descarga y se muestra reducido: asi el
          PNG sale del mismo canvas que se ve, sin volver a generarlo.
          Correccion H para que el logo del centro no lo vuelva ilegible.
        -->
        <div class="madm-qr">
          <qrcode
            #qr
            [qrdata]="linkCortoDe(e.origen)"
            [width]="ladoQr"
            [margin]="2"
            [errorCorrectionLevel]="'H'"
            [elementType]="'canvas'"
            [colorDark]="'#1A1F1A'"
          ></qrcode>
          <img class="madm-qr-logo" src="assets/icons/pwa/icon-512.png" alt="" />
        </div>

        <div class="madm-links">
          <span class="madm-links-label">Link corto: para redes y el QR</span>
          <div class="madm-links-fila">
            <code class="madm-url fuerte">{{ linkCortoVisible(e.origen) }}</code>
            <button class="madm-btn" (click)="copiar(e.origen, 'corto')">
              {{ copiado === e.origen + ':corto' ? 'Copiado' : 'Copiar' }}
            </button>
          </div>

          <span class="madm-links-label">Link completo</span>
          <div class="madm-links-fila">
            <code class="madm-url">{{ linkDe(e.origen) }}</code>
            <button class="madm-btn sec" (click)="copiar(e.origen, 'largo')">
              {{ copiado === e.origen + ':largo' ? 'Copiado' : 'Copiar' }}
            </button>
          </div>

          <button
            class="madm-btn madm-descargar"
            [disabled]="descargando === e.origen"
            (click)="descargarQr(e.origen, i)"
          >
            {{ descargando === e.origen ? 'Generando…' : 'Descargar QR (PNG)' }}
          </button>
        </div>
      </div>

      <div class="madm-nums">
        <div class="madm-num" *ngFor="let p of pasos(e)">
          <span class="madm-num-label">{{ p.nombre }}</span>
          <span class="madm-num-valor">{{ p.valor | number }}</span>
          <span class="madm-num-pct" *ngIf="p.pct !== null">{{ p.pct }}% de los clics</span>
        </div>
      </div>
    </section>

    <section class="madm-registros">
      <h2>Quiénes se registraron por el link</h2>

      <div class="madm-vacio" *ngIf="!registros.length">
        Todavía nadie verificó su correo por el link en este rango.
      </div>

      <div class="madm-tabla-wrap" *ngIf="registros.length">
        <table class="madm-tabla">
          <thead>
            <tr>
              <th>Correo verificado</th>
              <th>Nombre</th>
              <th>Correo</th>
              <th>Estado</th>
              <th>KYC</th>
              <th>Fondeó</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of registros">
              <td>{{ r.correoVerificadoAt | date: 'dd/MM/yy HH:mm' }}</td>
              <td>{{ r.nombre || '—' }}</td>
              <td>{{ r.email }}</td>
              <td>{{ estadoDe(r) }}</td>
              <td><span class="madm-si" [class.on]="r.kycAprobado">{{ r.kycAprobado ? 'Sí' : 'No' }}</span></td>
              <td><span class="madm-si" [class.on]="r.fondeo">{{ r.fondeo ? 'Sí' : 'No' }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>
</div>
